import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const Save = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            d="M15.9648043,5 L6.45493848,5 C5.6525884,5 5,5.6525884 5,6.45493848 L5,17.5450615 C5,18.3474116 5.6525884,19 6.45493848,19 L17.5450615,19 C18.3474116,19 19,18.3474116 19,17.5450615 L19,8.53259062 L15.9648043,5 Z M12,17 C10.8953684,17 10,16.1046316 10,15 C10,13.8953684 10.8953684,13 12,13 C13.1046316,13 14,13.8953684 14,15 C14,16.1046316 13.1046316,17 12,17 Z M14,10 L7.00471123,10 L7.00471123,7 L14,7 L14,10 Z"
        />
    </StarryUIIcon>
);
